import React, { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom';
import { useApp } from "../../context/AppContext";
import { loginUser } from "../../apis/apiList/authApi";
import { lostPassword } from "../../apis/apiList/authApi";
import { useMessage } from "../../context/MessageContext";
import { TextField, InputAdornment, IconButton } from '@mui/material';
import { Visibility, VisibilityOff } from '@mui/icons-material';

function FirstFiftyHeader() {

    const { showMessage } = useMessage();
    const { login } = useApp();
    const [isLogin, setIsLogin] = useState(false)
    const [forgotLoading, setForgotLoading] = useState(false)
    const [isLostPass, setIsLostPass] = useState();

    const navigate = useNavigate();

    const [formData, setFormData] = useState({
        email: "",
        password: "",
    });
    const [errors, setErrors] = useState({});

    const [showPassword, setShowPassword] = useState(false);

  const handleTogglePassword = () => {
    setShowPassword((prev) => !prev);
  };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const validateForm = () => {
        let newErrors = {};
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

        if (!formData.email) {
            newErrors.email = "Email is required";
        } else if (!emailRegex.test(formData.email)) {
            newErrors.email = "Invalid email format";
        }

        if (!formData.password) {
            newErrors.password = "Password is required";
        } else if (formData.password.length < 3) {
            newErrors.password = "Password must be at least 3 characters";
        }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsLogin(true)

        if (validateForm()) {
            const userData = { email: formData.email, password: formData.password };
            try {
                const response = await loginUser(userData);
                if (response.success) {
                    login(response.user);
                    if(response.user.role == 'admin'){
                        // navigate("/profile");
                        navigate("/task/list");
                        setIsLogin(false)
                    } else {
                        if(response.user.orgId){
                            navigate(`/subs/org/${response.user.orgId}/projects`);
                        } else {
                            navigate("/select-organization");
                        }
                        // navigate(`/subs/org/${response.user.orgId}/projects`);
                        setIsLogin(false)
                    }
                    showMessage("User logged in successfully", "success");
                }
            } catch (err) {
                showMessage(err?.response?.data?.message, "error");
                setIsLogin(false)
            }
        } else {
            setIsLogin(false)
        }
    };

    const validateEmail = () => {
        let newErrors = {};
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

        if (!formData.email) {
            newErrors.email = "Email is required";
        } else if (!emailRegex.test(formData.email)) {
            newErrors.email = "Invalid email format";
        }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleLostPassSubmit = async (e) => {
        e.preventDefault();
        setForgotLoading(true)
        if (validateEmail()) {
            const userData = { email: formData.email };
            try {
                const response = await lostPassword(userData);
                // console.log('response', response)
                if (response.success) {
                    showMessage(response.message, 'success');
                    setForgotLoading(false)
                }
            } catch (err) {
                showMessage(err?.response?.data?.message, "error");
                setForgotLoading(false)
            }
        } else {
            setForgotLoading(false)
        }
    };

    const handleLostPass = () => {
        setIsLostPass(!isLostPass);
    };

    return (
        <header id="header">
            <div className="row ">
                <div className="header-section ">
                    <div className="container">
                        <div className="header-wrap ">
                            <div className="logo-section ">
                                <div className="image">
                                    <a href="index.html">
                                        <img src="./images/firstFifty-images/header-logo.png" alt="header logo" />
                                    </a>
                                </div>
                            </div>
                            <div className="login-form">
                                <div className="login-form-wrap">
                                    <form onSubmit={handleSubmit}>

                                        <div className="field username">

                                            <input
                                                type="text"
                                                placeholder="Email"
                                                name="email"
                                                required=""
                                                value={formData.email}
                                                onChange={handleChange}
                                            />
                                            {errors.email && (
                                                <p className="error" style={{fontSize: '12px'}}>{errors.email}</p>
                                            )}
                                        </div>

                                        <div className="field password">

                                            <input 
                                                type="password"
                                                placeholder=" Password"
                                                name="password"
                                                required=""
                                                value={formData.password}
                                                onChange={handleChange}
                                            />
                                            {errors.password && (
                                                <p className="error" style={{fontSize: '12px'}}>{errors.password}</p>
                                            )}
                                        </div>
                                        
                                        <div className="submit-btn">
                                            {isLogin ? <button disabled style={{backgroundColor: 'grey'}}>Login</button> : <button type="submit">Login</button> }
                                        </div>
                                    </form>

                                </div>
                            </div>
                            <div className="call-section">
                                <div className="phone-no">
                                    <a href="tel:(800) 820-6020">(800) 820-6020</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </header>
    )
}

export default FirstFiftyHeader